export default class TwilioCredentialsModel {
  public accountSid!: string;
  public authToken!: string;
}
